<template>
  <section>
    <v-card class="contenedor-principal">
      <v-layout row wrap>
        <v-flex xs12 md4>
          <div class="grey lighten-3 contenedor-sticky">
            <div class=" title py-3 px-3">
              Estructura organizacional
            </div>
            <v-divider></v-divider>
            <v-treeview
              :active.sync="active"
              :items="l_unidades"
              :open.sync="open"
              activatable
              active-class="primary--text"
              class="arbol "
              open-on-click
              transition
              item-text="nombre_unidad"
            >
              <template v-slot:prepend="{ item }">
                <v-icon
                  v-if="item.children && item.children.length == 0"
                  :color="item.id == selected.id ? 'blue' : ''"
                >
                  domain
                </v-icon>
              </template>
              <template v-slot:label="{ item }">
                <div class="arbol-label" @click="selectUnidad(item)">
                  <v-tooltip bottom>
                    <span
                      slot="activator"
                      :class="
                        item.id == selected.id
                          ? 'blue--text font-weight-bold'
                          : ''
                      "
                      ><b>{{ `(${item.sigla.trim()})` }}</b
                      >{{ `-${item.nombre_unidad}` }}</span
                    >
                    <span>{{ item.nombre_unidad }}</span>
                  </v-tooltip>
                </div>
              </template>
            </v-treeview>
          </div>
        </v-flex>
        <v-flex xs12 md8 text-xs-center>
          <div
            v-if="selected.id == -1"
            class="title grey--text text--lighten-1 font-weight-light mt-3"
            style="align-self: center;"
          >
            Seleccione una unidad
          </div>
          <v-card v-else :key="selected.id">
            <div class="mt-2 contenedor-dependencia">
              <ul class="lista-dependencia">
                <li
                  v-for="dependencia in selected.dependencia"
                  :key="dependencia"
                  class="blue--text"
                >
                  {{ dependencia }}
                </li>
              </ul>
            </div>

            <EstructuraUnidad
              :id_unidad="parseInt(selected.id)"
              :filtros_persona="{}"
              :campos_personales="['nro_item', 'cargo', 'puesto']"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </section>
</template>
<script>
import EstructuraUnidad from "./EstructuraUnidad.vue";
export default {
  props: ["dependencia_superior"],
  components: { EstructuraUnidad },
  data() {
    return {
      active: [],
      avatar: null,
      open: [],
      users: [],
      l_unidades: [],
      selected: { id: -1 },
      windowSize: {
        x: 0,
        y: 0
      }
    };
  },
  // computed: {
  //   breakpoint() {
  //     const myDiv = document.querySelector(".arbol");
  //     const width = myDiv.offsetWidth;
  //     const height = myDiv.offsetHeight;
  //     myDiv.style.setProperty("--size-tree", `${width}px`);
  //     console.log(`Ancho: ${width}px, Alto: ${height}px`);
  //     return this.$vuetify.breakpoint.name;
  //   }
  // },
  // watch: {
  //   breakpoint(newVal, oldVal) {}
  // },
  async created() {},
  async mounted() {
    await this.cargarUnidades();
    await this.cargarUnidadesRecursivamente();
  },
  methods: {
    // Metodo para seleccionar una unidad
    async selectUnidad(item) {
      if (item.id == this.selected.id) {
        this.selected = { id: -1 };
      } else {
        this.selected = item;
      }
    },

    async cargarUnidades() {
      let filters = { id_entidad: 35, id_estado: 17 };
      // Preguntamos si es la dependencia superior 1 (Despacho)
      if (this.dependencia_superior.nivel_org == 1) {
        filters.lista_nivel_org = [1, 2];
      } else {
        filters.id = this.dependencia_superior.id;
      }
      let l_tmp = await this.$query.select("unidad", filters, [
        "nombre_unidad",
        "sigla",
        "id"
      ]);
      // Asignamos dependencias
      l_tmp = l_tmp.map(ele => {
        return { ...ele, dependencia: [ele.nombre_unidad] };
      });
      // Ordenamos la lista
      this.l_unidades = l_tmp.sort((a, b) =>
        a.nombre_unidad.localeCompare(b.nombre_unidad)
      );
    },
    async cargarUnidadesRecursivamente() {
      for (let index = 0; index < this.l_unidades.length; index++) {
        const element = this.l_unidades[index];
        element.children = await this.cargarUnidadesHijos(element);
      }
      this.l_unidades = JSON.parse(JSON.stringify(this.l_unidades));
    },
    async cargarUnidadesHijos(unidad) {
      let l_tmp = [];
      l_tmp = await this.$query.select(
        "unidad",
        {
          parent_id: parseInt(unidad.id),
          excluye_nivel: [1],
          id_entidad: 35,
          id_estado: 17
        },
        ["nombre_unidad", "sigla", "id"]
      );
      // Preguntamos si tiene hijos
      if (l_tmp.length > 0) {
        // Ordenamos la lista
        l_tmp = l_tmp.sort((a, b) =>
          a.nombre_unidad.localeCompare(b.nombre_unidad)
        );
        for (let index = 0; index < l_tmp.length; index++) {
          const element = l_tmp[index];
          element.dependencia = [...unidad.dependencia, element.nombre_unidad];
          element.children = await this.cargarUnidadesHijos(element);
        }
      }

      return l_tmp;
    }
  }
};
</script>
<style lang="scss">
// $size-tree: 200px;
:root {
  --size-tree: 200px;
}
.contenedor-sticky {
  position: sticky !important;
  top: 4.8rem;
  z-index: 1;
}
.arbol {
  .v-treeview-node {
    .v-treeview-node__root {
      text-overflow: ellipsis !important;
      overflow-x: hidden !important;
    }
  }
  .arbol-label {
    // max-width: 100% !important;
    // min-width: 200px !important;
    // width: var(--size-tree);
    font-size: 1.05rem;
    letter-spacing: -0.5px;
    text-overflow: ellipsis !important;
    overflow-x: hidden !important;
  }
}
.lista-dependencia {
  list-style: none;
  line-height: 0.9;
  font-weight: 600;
}
.contenedor-dependencia {
  padding: 0.7rem 0rem;
  background: white;
  position: sticky !important;
  backdrop-filter: blur(8px);
  background: rgba(206, 240, 250, 0.8);
  box-shadow: 0px 0px 10px 2px rgba(5, 197, 255, 0.507);
  top: 4.8rem;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/components/ArbolUnidades.vue